export default function Loading({ message }: { message?: string }) {
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="w-6 h-6 border-2 border-border border-t-action-primary rounded-full animate-spin mb-4" />
      <p className="text-sm text-text-secondary">
        {message ?? 'Loading...'}
      </p>
    </div>
  )
}

export function FullPageLoading() {
  return (
    <div className="min-h-screen bg-bg-page flex items-center justify-center">
      <Loading />
    </div>
  )
}
